/* Nirvam — real Shopify Cart AJAX integration.
   Replaces the source design's in-memory mock cart with real
   /cart/add.js, /cart/change.js, /cart.js calls. */
(function () {
  'use strict';

  var productData = {};
  try {
    var dataEl = document.getElementById('nirvam-product-data');
    if (dataEl) productData = JSON.parse(dataEl.textContent || '{}');
  } catch (e) { /* leave empty */ }

  var settings = window.NirvamSettings || {};
  var routes = settings.routes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartGet: '/cart.js', cartUpdate: '/cart/update.js', checkout: '/checkout' };

  // ---- Shopify's public money-format helper (ported, not fetched from a CDN) ----
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatStr = format || '${{amount}}';

    function defaultOption(opt, def) { return typeof opt === 'undefined' ? def : opt; }

    function withDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatStr.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    switch (key) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return formatStr.replace(placeholderRegex, value);
  }

  function money(cents) {
    return formatMoney(cents, window.Shopify && window.Shopify.money_format);
  }

  // ---- DOM refs ----
  var overlay = document.querySelector('[data-cart-overlay]');
  var drawer = document.querySelector('[data-cart-drawer]');
  var rowsEl = document.querySelector('[data-cart-rows]');
  var emptyEl = document.querySelector('[data-cart-empty]');
  var footerEl = document.querySelector('[data-cart-footer]');
  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  var mrpSubtotalEl = document.querySelector('[data-cart-mrp-subtotal]');
  var saveRowEl = document.querySelector('[data-cart-save-row]');
  var discountLabelEl = document.querySelector('[data-cart-discount-label]');
  var saveAmountEl = document.querySelector('[data-cart-save-amount]');
  var checkoutBtn = document.querySelector('[data-cart-checkout]');
  var lineTemplate = document.getElementById('nv-cart-line-template');
  var fab = document.querySelector('[data-cart-fab]');
  var fabText = document.querySelector('[data-cart-fab-text]');
  var headerBadge = document.querySelector('[data-cart-badge]');
  var toastEl = document.querySelector('[data-cart-toast]');
  var shippingNudge = document.querySelector('[data-shipping-nudge]');
  var shippingNudgeText = document.querySelector('[data-shipping-nudge-text]');
  var shippingNudgeFill = document.querySelector('[data-shipping-meter-fill]');
  var cartShipMeterText = document.querySelector('[data-cart-ship-meter-text]');
  var cartShipMeterFill = document.querySelector('[data-cart-ship-meter-fill]');

  var toastTimer = null;
  function showToast(msg, ms) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-active');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-active'); }, ms || 2600);
  }

  function openDrawer() {
    if (drawer) drawer.classList.add('is-active');
    if (overlay) overlay.classList.add('is-active');
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-active');
    if (overlay) overlay.classList.remove('is-active');
  }

  var popup = document.querySelector('[data-sherni-popup]');
  function closePopup() { if (popup) popup.classList.remove('is-active'); }

  // ---- Cart fetch / mutate ----
  function fetchCart() {
    return fetch(routes.cartGet, { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; });
    });
  }

  function addToCart(variantId, quantity) {
    return postJSON(routes.cartAdd, { items: [{ id: Number(variantId), quantity: quantity }] })
      .then(function (res) {
        if (!res.ok) {
          var desc = (res.data && (res.data.description || res.data.message)) || 'Could not add that item to your bag.';
          showToast(desc);
          fetchCart();
          return null;
        }
        return fetchCart().then(function (cart) { openDrawer(); return cart; });
      })
      .catch(function () { showToast('Something went wrong. Please try again.'); });
  }

  function changeLine(variantId, quantity) {
    return postJSON(routes.cartChange, { id: String(variantId), quantity: quantity })
      .then(function (res) {
        if (!res.ok) {
          var desc = (res.data && (res.data.description || res.data.message)) || 'Could not update your bag.';
          showToast(desc);
        }
        return fetchCart();
      })
      .catch(function () { showToast('Something went wrong. Please try again.'); });
  }

  function removeLine(variantId) { return changeLine(variantId, 0); }

  // MRP (compare-at price) for a cart line's unit, falling back to the actual price
  // when the product has no compare-at set.
  function unitMrp(item) {
    var meta = productData[String(item.variant_id)];
    return (meta && meta.compareAtPrice) ? meta.compareAtPrice : item.price;
  }

  function checkout() {
    window.location.href = routes.checkout;
  }

  // ---- Rendering ----
  function render(cart) {
    var count = cart.item_count || 0;

    // Header badge
    if (headerBadge) {
      headerBadge.textContent = String(count);
      headerBadge.style.display = count > 0 ? 'grid' : 'none';
    }

    // FAB
    if (fab && fabText) {
      fab.classList.toggle('is-active', count > 0 && !(drawer && drawer.classList.contains('is-active')));
      fabText.textContent = count + ' in bag · ' + money(cart.total_price);
    }

    // Empty vs populated state
    if (emptyEl) emptyEl.style.display = count > 0 ? 'none' : 'flex';
    if (rowsEl) rowsEl.style.display = count > 0 ? 'flex' : 'none';
    if (footerEl) footerEl.style.display = count > 0 ? 'flex' : 'none';

    if (count > 0) {
      renderRows(cart);

      var mrpSub = 0;
      cart.items.forEach(function (item) {
        mrpSub += unitMrp(item) * item.quantity;
      });
      if (mrpSubtotalEl) mrpSubtotalEl.textContent = money(mrpSub);

      var saved = mrpSub - cart.total_price;
      if (saveRowEl && saveAmountEl) {
        if (saved > 0) {
          var pct = mrpSub > 0 ? Math.round((saved / mrpSub) * 100) : 0;
          saveRowEl.style.display = 'flex';
          if (discountLabelEl) discountLabelEl.textContent = 'Discount Applied (' + pct + '%)';
          saveAmountEl.textContent = '−' + money(saved);
        } else {
          saveRowEl.style.display = 'none';
        }
      }

    }

    // Box count drives the free-delivery threshold — one cart unit is one
    // box — and mirrors onto a `free_shipping_eligible` cart attribute for
    // the Shiprocket/Fastrr checkout's own "Shipping Charge" rule (see
    // syncFreeShipAttribute).
    var eligible = count >= FREE_SHIP_BOX_QTY || hasFreeShipDiscountCode(cart);
    syncFreeShipAttribute(eligible);

    updateShippingDisplays(cart.total_price, count, eligible);
  }

  // ---- Delivery fee: FREE from this many boxes up, decided purely by the
  // number of boxes in the bag — or when a free-shipping discount code (e.g.
  // FRIEND) is applied, regardless of quantity. The actual per-destination
  // fee below the threshold is calculated by Fastrr/Shiprocket checkout
  // itself (see syncFreeShipAttribute) — this theme no longer guesses it. --
  var FREE_SHIP_BOX_QTY = Number(settings.freeShipBoxQty) || 2;

  // Codes that should waive shipping outright, independent of box count.
  // Shopify's own "Free Shipping" discount type has nothing to act on here —
  // it waives Shopify's own calculated shipping rate, but Fastrr/Shiprocket
  // checkout never asks Shopify for one (it calculates its own via its rule
  // engine). So a code meant to give free shipping has to flow through the
  // same `free_shipping_eligible` cart attribute as the box-count threshold.
  var FREE_SHIP_DISCOUNT_CODES = ['FRIEND'];

  function hasFreeShipDiscountCode(cart) {
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i].applicable && FREE_SHIP_DISCOUNT_CODES.indexOf((codes[i].code || '').toUpperCase()) !== -1) return true;
    }
    return false;
  }

  // Mirrors the free-shipping decision onto a `free_shipping_eligible` cart
  // attribute ("true"/"false") so the Shiprocket/Fastrr checkout rule engine
  // — which has no visibility into Shopify discount codes — can key its own
  // "Shipping Charge" rule off a Cart Attributes condition instead of
  // Invoice Value (post-discount) or MRP (which moves with future storewide
  // sales). Only fires a request when the eligibility actually flips, so it
  // doesn't spam /cart/update.js on every render.
  var lastFreeShipEligible = null;
  function syncFreeShipAttribute(eligible) {
    if (eligible === lastFreeShipEligible) return;
    lastFreeShipEligible = eligible;
    postJSON(routes.cartUpdate, { attributes: { free_shipping_eligible: eligible ? 'true' : 'false' } }).catch(function () {});
  }

  // `cartTotal` is the real payable amount (after any discount) — used for
  // the displayed order total. `boxCount` drives the progress messaging
  // toward the box threshold. `eligible` is the final free/not decision
  // (threshold OR a free-shipping code). The per-destination fee itself is
  // no longer estimated here — it's shown at Fastrr/Shiprocket checkout
  // once the shopper enters their address.
  function updateShippingDisplays(cartTotal, boxCount, eligible) {
    var valEls = document.querySelectorAll('[data-cart-ship-val]');
    for (var i = 0; i < valEls.length; i++) {
      valEls[i].textContent = eligible ? 'FREE' : 'Calculated at checkout';
      valEls[i].style.color = eligible ? 'var(--success)' : 'var(--sepia-500)';
    }
    if (subtotalEl) subtotalEl.textContent = money(cartTotal);

    var pct = Math.max(0, Math.min(100, (boxCount / FREE_SHIP_BOX_QTY) * 100));
    var text;
    if (eligible) {
      text = 'Free shipping unlocked.';
    } else {
      var remaining = FREE_SHIP_BOX_QTY - boxCount;
      text = 'Add ' + remaining + (remaining === 1 ? ' more box' : ' more boxes') + ' for FREE delivery';
    }
    if (shippingNudgeText) shippingNudgeText.textContent = text;
    if (shippingNudgeFill) shippingNudgeFill.style.width = pct + '%';
    if (cartShipMeterText) cartShipMeterText.textContent = text;
    if (cartShipMeterFill) cartShipMeterFill.style.width = pct + '%';

    return { free: eligible };
  }

  function renderRows(cart) {
    if (!rowsEl || !lineTemplate) return;
    rowsEl.innerHTML = '';
    cart.items.forEach(function (item) {
      var meta = productData[String(item.variant_id)] || {};
      var frag = lineTemplate.content.cloneNode(true);
      var img = frag.querySelector('[data-line-image]');
      if (img) {
        img.src = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') : '';
        img.alt = item.title || '';
      }
      var titleEl = frag.querySelector('[data-line-title]');
      if (titleEl) titleEl.textContent = item.product_title || meta.title || item.title;
      var sizeEl = frag.querySelector('[data-line-size]');
      if (sizeEl) sizeEl.textContent = meta.size || '';
      var qtyEl = frag.querySelector('[data-line-qty]');
      if (qtyEl) qtyEl.textContent = String(item.quantity);
      var priceEl = frag.querySelector('[data-line-price]');
      if (priceEl) priceEl.textContent = money(unitMrp(item) * item.quantity);

      var root = frag.querySelector('.nv-cart-line');
      if (root) {
        root.setAttribute('data-variant-id', item.variant_id);
        var inc = frag.querySelector('[data-line-increase]');
        var dec = frag.querySelector('[data-line-decrease]');
        var rm = frag.querySelector('[data-line-remove]');
        if (inc) inc.addEventListener('click', function () { changeLine(item.variant_id, item.quantity + 1); });
        if (dec) dec.addEventListener('click', function () {
          if (item.quantity <= 1) removeLine(item.variant_id);
          else changeLine(item.variant_id, item.quantity - 1);
        });
        if (rm) rm.addEventListener('click', function () { removeLine(item.variant_id); });
      }
      rowsEl.appendChild(frag);
    });
  }

  // ---- Product card / slide wiring (event delegation) ----
  function clampQty(el, qty) {
    var max = 99;
    var inv = el.getAttribute('data-inventory');
    var policy = el.getAttribute('data-inventory-policy');
    if (inv !== null && inv !== '' && policy !== 'continue') {
      var invNum = parseInt(inv, 10);
      if (!isNaN(invNum) && invNum > 0) max = invNum;
    }
    return Math.max(1, Math.min(max, qty));
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-product-card]');

    if (e.target.closest('[data-qty-increase]') && card) {
      var valEl = card.querySelector('[data-qty-value]');
      var cur = parseInt(valEl.textContent, 10) || 1;
      valEl.textContent = String(clampQty(card, cur + 1));
      return;
    }
    if (e.target.closest('[data-qty-decrease]') && card) {
      var valEl2 = card.querySelector('[data-qty-value]');
      var cur2 = parseInt(valEl2.textContent, 10) || 1;
      valEl2.textContent = String(clampQty(card, cur2 - 1));
      return;
    }
    if (e.target.closest('[data-add-to-cart]') && card) {
      var qtyEl2 = card.querySelector('[data-qty-value]');
      var qty = qtyEl2 ? (parseInt(qtyEl2.textContent, 10) || 1) : 1;
      var variantId = card.getAttribute('data-variant-id');
      addToCart(variantId, qty).then(function () {
        if (qtyEl2) qtyEl2.textContent = '1';
      });
      return;
    }
    if (e.target.closest('[data-add-to-cart-one]') && card) {
      var variantId2 = card.getAttribute('data-variant-id');
      addToCart(variantId2, 1);
      return;
    }

    // Cart open/close
    if (e.target.closest('[data-cart-open]')) { openDrawer(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) { closeDrawer(); return; }
    if (e.target.closest('[data-cart-checkout]')) { checkout(); return; }

    // Popup close
    if (e.target.closest('[data-popup-close]')) { closePopup(); return; }

    // Floating coupon badge — copy the code to the clipboard
    if (e.target.closest('[data-coupon-fab]')) { copyCouponCode(); return; }
  });

  var COUPON_CODE = (window.NirvamSettings && window.NirvamSettings.couponCode) || 'SHERNI15';
  function copyCouponCode() {
    function done(ok) { showToast(ok ? 'Code ' + COUPON_CODE + ' copied!' : 'Code: ' + COUPON_CODE); }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(COUPON_CODE).then(function () { done(true); }, function () { done(false); });
      return;
    }
    try {
      var ta = document.createElement('textarea');
      ta.value = COUPON_CODE;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      done(ok);
    } catch (e) { done(false); }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closePopup(); }
  });

  // Expose a small public API for other scripts / inline handlers
  window.NirvamCart = {
    addToCart: addToCart,
    changeLine: changeLine,
    removeLine: removeLine,
    fetchCart: fetchCart,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer,
    checkout: checkout,
    showToast: showToast,
    money: money
  };

  document.addEventListener('DOMContentLoaded', function () { fetchCart(); });
})();
